// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Fax: React.FC = () => {
    return <svg 
                xmlns="http://www.w3.org/2000/svg" 
                viewBox="0 0 32 33"  
                strokeWidth="2" 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                focusable="false" 
                width="24" 
                height="24" 
                fill="currentColor"
            >
                <path 
                    d="M28 12.5H4c-2.21 0-4 1.794-4 4v6a2 2 0 002 2h2v6a2 2 0 002 2h20a2 2 0 002-2v-6h2a2 2 0 002-2v-6c0-2.206-1.794-4-4-4zm-4 16H8v-6h16v6zm3-9.5a1.5 1.5 0 110-3 1.5 1.5 0 010 3zM8 4.5h14.344L24 6.157V10.5h4V5.328a2 2 0 00-.586-1.414l-2.828-2.828A1.998 1.998 0 0023.175.5H6a2 2 0 00-2 2v8h4v-6z"
                />
            </svg>;
};

export default React.memo(Fax);


